import { Col, Form, Input, Row, Typography } from "antd";
const { Text } = Typography;

const CurrencyConfig = (props) => {
  const {
    onFinish,
    form,
    formData,
    glDetail,
    revaluationGlAccountData = [],
  } = props;
  const revaluationGlAccountName = revaluationGlAccountData.find(
    (o) =>
      o.value ===
      (glDetail?.revaluationGlAccount || glDetail?.revaluationGlAccountId),
  )?.label;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const yesNo = (value) =>
    value === true ? "Yes" : value === false ? "No" : "-";
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Currency Code</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                glDetail?.currencyData?.displayLabel ||
                glDetail?.currencyData?.code ||
                glDetail?.currencyCode ||
                "All Currencies"
              }
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Multi Currency Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.multiCurrencyAllowed)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Revaluation Required</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.revaluationRequired)}
            />
          </Form.Item>
        </Col>
        {glDetail?.revaluationRequired === true && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Revaluation GL Account</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={displayValue(revaluationGlAccountName)}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default CurrencyConfig;
